import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";

export const getNotes = (referenceId: any) => http({
    url: ENDPOINTS.cartable.notes,
    method: 'get',
    headers: { "Accept-Language": "en" },
    params: {
        referenceId
    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject( err);
});